import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import { PAYMENT_METHOD_LABEL_SHIFT } from 'utils/paymentMethodConstants';
import ShiftDetailRow from '../ShiftDetailRow/ShiftDetailRow';

class ShiftDetailEDC extends React.Component {
  render() {
    const { shift } = this.props;
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group col-sm-12 label-section">
            <label>EDC</label>
          </div>
          <div className="col-sm-12 other_detail no-padding-right">
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.BCA}
              value={currencyFormatter(shift.total_bca)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.MANDIRI}
              value={currencyFormatter(shift.total_mandiri)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.BRI}
              value={currencyFormatter(shift.total_bri)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.BNI}
              value={currencyFormatter(shift.total_bni)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.CIMB_NIAGA}
              value={currencyFormatter(shift.total_cimb_niaga)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.OTHER_EDC}
              value={currencyFormatter(shift.total_other_edc)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.EDC_REFUNDS}
              value={currencyFormatter(`-${shift.total_edc_refunds}`)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.EDC_EXPECTED_PAYMENT}
              value={currencyFormatter(shift.expected_edc_payment)}
            />
          </div>
        </div>
      </div>
    );
  }
}

ShiftDetailEDC.propTypes = {
  shift: PropTypes.object,
};

export default ShiftDetailEDC;
